import * as Sentry from '@sentry/react'

type Replay = NonNullable<ReturnType<typeof Sentry.getReplay>>

let markAdded: () => void = () => undefined
const added = new Promise<void>((resolve) => {
  markAdded = resolve
})

/** Called once the replay integration, which `index.tsx` adds lazily, is in place. */
export const replayIntegrationAdded = (): void => markAdded()

let converting: Promise<void> | undefined

/* flush() starts a replay that is not running, and turns a buffering one (last 60 s) into a sent session */
const record = (replay: Replay) => {
  if (converting || replay.getRecordingMode() === 'session') {
    return
  }
  converting = replay
    .flush()
    .catch(() => undefined)
    .finally(() => {
      converting = undefined
    })
}

const attempt = (): boolean => {
  try {
    const replay = Sentry.getReplay()
    if (replay) {
      record(replay)
    }
    return !!replay
  } catch {
    return true
  }
}

/** Records this browser session in full from now on, whatever the replay sampling decided. Default masking applies. */
export const recordWholeSession = (): void => {
  if (!attempt()) {
    void added.then(attempt)
  }
}
